// Mock data for Sandgen Landing Page - Premium Branding

export const heroData = {
  tagline: "THE FUTURE OF TALENT",
  headline: "HIRE SMARTER. FASTER. BETTER.",
  subheadline: "While others search, you discover. Sandgen's neural intelligence doesn't just find candidates—it understands them.",
  cta: "Experience Sandgen",
  secondaryCta: "See It In Action"
};

export const statsData = [
  { value: "87%", label: "Faster Than Traditional" },
  { value: "3.2x", label: "Superior Match Rate" },
  { value: "50k+", label: "Elite Placements" },
  { value: "500+", label: "Visionary Companies" }
];

export const coreFeatures = [
  {
    id: "vault",
    title: "Sandgen Vault",
    description: "Military-grade security meets elegant simplicity. OAuth, RBAC, and permissions so refined, they're invisible.",
    icon: "Shield"
  },
  {
    id: "flow",
    title: "Sandgen Flow",
    description: "Your hiring pipeline, elevated. Custom stages that bend to your will, not the other way around.",
    icon: "GitBranch"
  },
  {
    id: "pool",
    title: "Sandgen Talent Pool",
    description: "Every candidate, curated. AI-parsed profiles that reveal the person behind the résumé.",
    icon: "Users"
  },
  {
    id: "prove",
    title: "Sandgen Prove",
    description: "Assessments that actually assess. Proctored, precise, and impossibly fair.",
    icon: "FileCheck"
  },
  {
    id: "mind",
    title: "Sandgen Mind",
    description: "Intelligence that thinks like you do—only faster, deeper, and without the coffee breaks.",
    icon: "Sparkles"
  },
  {
    id: "stage",
    title: "Sandgen Stage",
    description: "Where great interviews happen. Collaborate, evaluate, and never miss a moment.",
    icon: "Video"
  }
];

export const iamFeatures = {
  organization: [
    "Effortless authentication via Email/Password and OAuth",
    "Sophisticated organization onboarding",
    "Role-Based Access that actually makes sense",
    "Permissions so granular, they're almost obsessive",
    "Staff management that manages itself"
  ],
  candidate: [
    "Frictionless candidate registration",
    "Unified identity across every touchpoint",
    "One-click access to assessments and interviews",
    "Personal profiles that tell the whole story"
  ]
};

export const pipelineStages = [
  { stage: "Application", description: "First impressions, perfected. Custom forms that capture what matters." },
  { stage: "Evaluation", description: "Beyond the résumé. Assessments that reveal true potential." },
  { stage: "Interview", description: "Conversations that count. Structured, recorded, unforgettable." },
  { stage: "Offer", description: "The grand finale. Digital offers that close deals." }
];

export const candidateFeatures = [
  {
    title: "The Unified Pool",
    description: "Every candidate, one place. Search, filter, and discover with unmatched precision.",
    icon: "Database"
  },
  {
    title: "Neural Parsing",
    description: "Résumés decoded. Skills extracted. Experience normalized. Automatically.",
    icon: "Brain"
  },
  {
    title: "Intelligent Shortlisting",
    description: "Let the algorithm do the heavy lifting. You make the final call.",
    icon: "Filter"
  },
  {
    title: "Mass Communication",
    description: "Reach thousands personally. Templates that don't feel like templates.",
    icon: "Mail"
  }
];

export const assessmentFeatures = [
  "Timed sections with surgical precision",
  "Question banks that evolve with you",
  "Scheduling that respects everyone's time",
  "Proctoring so seamless, candidates forget it's there",
  "Analytics that reveal the invisible",
  "Mock tests for the truly prepared",
  "Performance tracking across dimensions"
];

export const aiFeatures = [
  {
    title: "Neural Scoring",
    description: "Every candidate, quantified. JD alignment measured to the decimal.",
    icon: "Target"
  },
  {
    title: "Deep Résumé Analysis",
    description: "We don't read résumés. We understand them.",
    icon: "FileSearch"
  },
  {
    title: "Semantic Search",
    description: "Search in plain English. Find in milliseconds.",
    icon: "Search"
  },
  {
    title: "Autonomous Workflows",
    description: "Set the rules. Watch them execute. Perfectly. Every time.",
    icon: "Workflow"
  }
];

export const interviewFeatures = {
  management: [
    "Schedule with a single click",
    "Assign panelists who actually show up",
    "Secure links that just work",
    "Rubrics that eliminate bias",
    "Recordings for posterity"
  ],
  live: [
    "Interview rooms that feel like being there",
    "Code editors that keep pace with thought",
    "20+ languages, zero excuses",
    "Real-time execution, real-time results",
    "Moderator controls for when things get interesting"
  ]
};

export const ragFeatures = [
  {
    title: "Semantic Understanding",
    description: "RAG-powered matching that comprehends context, not just keywords."
  },
  {
    title: "JD Deconstruction",
    description: "We break down job descriptions so thoroughly, even you'll learn something new."
  },
  {
    title: "Scoped Precision",
    description: "Recommendations from your pool only. Your talent stays yours."
  },
  {
    title: "Confidence Ranking",
    description: "Every match comes with a number. The higher, the better. Simple."
  }
];

export const analyticsMetrics = [
  { metric: "Application Volume", icon: "BarChart3" },
  { metric: "Stage Conversion", icon: "TrendingUp" },
  { metric: "Success Rates", icon: "CheckCircle" },
  { metric: "Audit Trail", icon: "History" }
];

export const techHighlights = [
  { title: "Microservices", description: "Modular. Scalable. Unstoppable." },
  { title: "Fort Knox Security", description: "Your data, under lock and key." },
  { title: "Real-Time Everything", description: "If it's not instant, it's not Sandgen." },
  { title: "AI-Native", description: "Built for intelligence from day one." }
];

export const pricingPlans = [
  {
    name: "Starter",
    price: "$299",
    period: "/month",
    description: "For teams ready to elevate",
    features: [
      "Up to 50 candidates/month",
      "3 active pipelines",
      "Sandgen Prove Basic",
      "Priority email support"
    ],
    highlighted: false
  },
  {
    name: "Professional",
    price: "$799",
    period: "/month",
    description: "For organizations that mean business",
    features: [
      "Up to 500 candidates/month",
      "Unlimited pipelines",
      "Full Sandgen Intelligence",
      "Sandgen Stage access",
      "Dedicated success partner"
    ],
    highlighted: true
  },
  {
    name: "Enterprise",
    price: "Custom",
    period: "",
    description: "For those who demand the absolute best",
    features: [
      "Unlimited everything",
      "Custom integrations",
      "White-glove onboarding",
      "SLA guarantees",
      "On-premise available"
    ],
    highlighted: false
  }
];

export const testimonials = [
  {
    quote: "Redsage's assessment tool and LMS have raised the bar for how our learners experience coursework and evaluation. The platform is intuitive for students, reliable for faculty, and powerful for program operations.",
    author: "Dr. Prashant Dey",
    role: "Program Director, Tech, Hero Vired",
    avatar: "PD"
  },
  {
    quote: "Redsage is dependable when it comes to resilience and real-world problem-solving. They took on complex AI workflows, stayed calm under pressure, and delivered a dependable solution that just works. What stood out was their partnership mindset-clear communication, thoughtful choices, and a get-it-done attitude. We trust Redsage with our toughest projects.",
    author: "Mr. Chiranjeevi Velagala",
    role: "AGM - IT & Digital, Hetero Healthcare",
    avatar: "CV"
  }
];

export const footerLinks = {
  product: [
    { label: "The Suite", href: "/features" },
    { label: "Investment", href: "/pricing" },
    { label: "Sandgen Connect", href: "/platform" },
    { label: "What's New", href: "#" }
  ],
  company: [
    { label: "Our Story", href: "/about" },
    { label: "Journal", href: "#" },
    { label: "Join Us", href: "#" },
    { label: "Get In Touch", href: "#" }
  ],
  resources: [
    { label: "Documentation", href: "#" },
    { label: "Support Center", href: "#" },
    { label: "API Reference", href: "#" },
    { label: "System Status", href: "#" }
  ],
  legal: [
    { label: "Privacy", href: "#" },
    { label: "Terms", href: "#" },
    { label: "Security", href: "#" }
  ]
};

export const navLinks = [
  { label: "The Suite", href: "/features" },
  { label: "Platform", href: "/platform" },
  { label: "Investment", href: "/pricing" },
  { label: "Our Story", href: "/about" }
];
